"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBrowserPrompt = void 0;
var react_1 = require("react");
var useBrowserPrompt = function (block) {
    (0, react_1.useEffect)(function () {
        if (!block) {
            return;
        }
        var confirmExit = function (e) {
            e.preventDefault();
            return (e.returnValue = 'The form contains unsaved changes. If you leave, you will loose those chnages. Do you want to continue?');
        };
        window.addEventListener('beforeunload', confirmExit);
        return function () {
            window.removeEventListener('beforeunload', confirmExit);
        };
    }, [block]);
};
exports.useBrowserPrompt = useBrowserPrompt;
//# sourceMappingURL=BrowserPrompt.js.map